import type { SVGProps } from "react";

/**
 * creatify
 * @category Social Media & Brands
 */
export default function IconCreatify(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 32 32' fill='none' aria-hidden {...props}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='m18.735 19.62 6.06-3.498a.14.14 0 0 0 0-.242l-6.06-3.498a.14.14 0 0 0-.21.12V19.5a.14.14 0 0 0 .21.121m-3.08-8.946c0-1.142.936-1.96 1.959-1.96.325 0 .66.084.975.266l9.226 5.326c1.304.753 1.304 2.636 0 3.389l-9.226 5.325c-.315.183-.65.266-.975.266-1.021 0-1.96-.818-1.96-1.959zm-3.099-1.926H6.718c0 1.59 1.29 2.88 2.88 2.88h2.958a1.441 1.441 0 0 0 0-2.88M8.87 20.072h3.687a1.441 1.441 0 0 1 0 2.88h-.807c-1.589 0-2.88-1.29-2.88-2.88m3.687-5.662H3.207c0 1.59 1.29 2.88 2.88 2.88h6.47a1.441 1.441 0 0 0 0-2.88'
        clipRule='evenodd'
      />
    </svg>
  );
}
